import { grafitFileSchema } from "@grafit/shared/domain/file/file.validation";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SupplierQuoteReceivedPage } from "../../../../pages/supplier-quote-received-page/supplier-quote-received-page";

export const Route = createFileRoute("/_auth/_project/supplier-quote-request/$projectId/$subProjectId/received-quotes")(
  {
    component: SupplierQuoteReceivedPage,
    validateSearch: z.object({
      pendingQuoteFileId: grafitFileSchema.shape.id.optional(),
    }),
  },
);
